/* =====================================================================
   TP PRODUCT · Página de producto de The Tile Plug
   ---------------------------------------------------------------------
   - Calculadora simple: sq ft y cajas/hojas a la vista y conectados.
     Escribe sq ft → cajas completas (con 10%, 15% o 20% extra por cortes).
     Cambia las cajas → cuántos sq ft cubren. Productos por unidad: cantidad.
   - Botón "Add N boxes to cart · $X" (carrito por AJAX + aviso).
   - "Order sample", corazón de favoritos (Wishlist Plus).
   - Colores y tamaños: nombre al pasar el mouse, carga anticipada y la
     calculadora recuerda los sq ft al cambiar de color o tamaño.
   - Si el producto tiene variantes, se actualiza al cambiar de variante.
   Usa las herramientas de tp-card.js (window.TP) si están disponibles.
   ===================================================================== */
(function () {
  'use strict';

  if (window.__tpPdpReady) return;
  window.__tpPdpReady = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAX_UNITS = 9999;
  var STORE_KEY = 'tp-calc';
  var STORE_TTL = 2 * 60 * 60 * 1000; // 2 horas
  // Porcentajes válidos de extra por cortes
  var WASTE_TXT = { 10: true, 15: true, 20: true };

  /* ---------- Utilidades ---------- */

  // Dinero en dólares (centavos → "$1,234.56")
  function money(cents) {
    if (window.TP && typeof window.TP.money === 'function') return window.TP.money(cents);
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Redondeo a 2 decimales para sq ft
  function num(n) {
    return String(Math.round((Number(n) || 0) * 100) / 100);
  }

  function word(unit, n) {
    if (unit === 'box') return n === 1 ? 'box' : 'boxes';
    if (unit === 'sheet') return n === 1 ? 'sheet' : 'sheets';
    return n === 1 ? 'item' : 'items';
  }

  function toInt(v, fallback) {
    var n = parseInt(v, 10);
    return isNaN(n) ? fallback : n;
  }

  function clamp(n, min, max) {
    return Math.min(Math.max(n, min), max);
  }

  function readStore() {
    try {
      var raw = window.sessionStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStore(obj) {
    try {
      window.sessionStorage.setItem(STORE_KEY, JSON.stringify(obj));
    } catch (e) { /* sin acción */ }
  }

  /* ---------- Carrito (usa tp-card.js si está) ---------- */

  function addToCart(items) {
    if (window.TP && typeof window.TP.addToCart === 'function') return window.TP.addToCart(items);
    return fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items }, function (k, v) { return k === 'sample' ? undefined : v; })
    })
      .then(function (r) {
        return r.json().then(function (data) { return { ok: r.ok, data: data }; });
      })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error(res.data.description || res.data.message || 'This item could not be added to your cart.');
        }
        return res.data;
      });
  }

  function toast(opts) {
    if (window.TP && typeof window.TP.toast === 'function') {
      window.TP.toast(opts);
      return;
    }
    // Respaldo: sin aviso disponible, se va al carrito
    if (!opts.error) window.location.href = ROOT + 'cart';
  }

  /* ---------- Kit: cosas marcadas "Add with tile" ---------- */

  // Formato grande (12x24, 24x48 o más) según el título
  function bigTile(title) {
    var m = /(\d+(?:\.\d+)?)\s*["”]?\s*[x×]\s*(\d+(?:\.\d+)?)/i.exec(title || '');
    if (!m) return false;
    var a = parseFloat(m[1]), b = parseFloat(m[2]);
    return Math.min(a, b) >= 12 && Math.max(a, b) >= 24;
  }

  // Cantidad sugerida: grout según lo que cubre una bolsa en ESTE azulejo (lo
  // calcula el robot: data-sqft-bag); thinset por sq ft (bolsa de 50 lb ≈ 40 sq ft
  // en formato grande, ≈ 75 sq ft en formato chico); lo demás, 1.
  function kitQty(cb, sqft, big) {
    var bag = parseFloat(cb.getAttribute('data-sqft-bag'));
    if (cb.getAttribute('data-kind') === 'grout' && bag > 0 && sqft > 0) return Math.max(1, Math.ceil(sqft / bag - 1e-9));
    if (cb.getAttribute('data-kind') !== 'thinset' || !(sqft > 0)) return 1;
    var lb = parseFloat(cb.getAttribute('data-lb')) || 50;
    var per = (big ? 40 : 75) * lb / 50;
    return Math.max(1, Math.ceil(sqft / per - 1e-9));
  }

  // Grout: la combinación de bolsas más barata para los sq ft de este azulejo (p. ej. 1 × 25 lb + 1 × 10 lb).
  // data-mix = {lb, sqftLb, alt: {id, cents, lb}} lo pone tp-product.liquid. Sin datos → null (cálculo de siempre).
  function groutMix(cb, sqft) {
    var m;
    try { m = JSON.parse(cb.getAttribute('data-mix') || 'null'); } catch (e) { m = null; }
    if (!m || !(Number(m.sqftLb) > 0) || !(Number(m.lb) > 0)) return null;
    var a = { id: Number(cb.getAttribute('data-tp-kit-pick')), price: toInt(cb.getAttribute('data-price'), 0), lb: Number(m.lb) };
    var b = m.alt && m.alt.id && Number(m.alt.lb) > 0 ? { id: Number(m.alt.id), price: toInt(m.alt.cents, 0), lb: Number(m.alt.lb) } : null;
    var small = b && b.lb < a.lb ? b : a, large = b && b.lb > a.lb ? b : null;
    var need = sqft > 0 ? sqft / Number(m.sqftLb) : 0;
    var best = null;
    var maxL = large ? Math.ceil(need / large.lb - 1e-9) : 0;
    for (var nL = 0; nL <= maxL; nL++) {
      var rest = need - nL * (large ? large.lb : 0);
      var nS = rest > 1e-9 ? Math.ceil(rest / small.lb - 1e-9) : 0;
      if (nS + nL === 0) nS = 1;
      var cost = nS * small.price + nL * (large ? large.price : 0);
      if (!best || cost < best.cost || (cost === best.cost && nS + nL < best.n)) best = { cost: cost, n: nS + nL, nS: nS, nL: nL };
    }
    var out = [];
    if (large && best.nL) out.push({ id: large.id, qty: best.nL, price: large.price, lb: large.lb });
    if (best.nS) out.push({ id: small.id, qty: best.nS, price: small.price, lb: small.lb });
    return out;
  }

  function kitPicks(el, sqft, big) {
    var out = [];
    el.querySelectorAll('[data-tp-kit-pick]').forEach(function (cb) {
      var mix = cb.getAttribute('data-kind') === 'grout' ? groutMix(cb, sqft) : null;
      if (mix) {
        var h = cb.parentNode && cb.parentNode.querySelector('[data-tp-kit-qty]');
        if (h) h.textContent = ' · ' + mix.map(function (x) { return x.qty + ' × ' + x.lb + ' lb'; }).join(' + ');
        if (cb.checked) mix.forEach(function (x) { out.push({ id: x.id, qty: x.qty, price: x.price }); });
        return;
      }
      var q = kitQty(cb, sqft, big);
      var hint = cb.parentNode && cb.parentNode.querySelector('[data-tp-kit-qty]');
      if (hint) hint.textContent = q > 1 ? ' · ' + q + ' bags' : '';
      if (!cb.checked) return;
      out.push({ id: Number(cb.getAttribute('data-tp-kit-pick')), qty: q, price: toInt(cb.getAttribute('data-price'), 0) });
    });
    return out;
  }

  /* ---------- Página de producto ---------- */

  function Pdp(buy) {
    var d = buy.dataset;
    this.el = buy;
    this.scope = buy.closest('.product__info-container, [id^="ProductInfo-"]') || document;
    this.head = this.scope.querySelector('[data-tp-pdp-head]') || document.querySelector('[data-tp-pdp-head]');
    this.s = {
      productId: d.productId || '',
      title: d.title || '',
      url: d.url || '',
      variant: d.variant || '',
      price: toInt(d.price, 0),
      available: d.available === 'true',
      cover: parseFloat(d.cover) || 0,
      unit: d.unit || 'unit',
      sampleVariant: d.sampleVariant || '',
      samplePrice: toInt(d.samplePrice, 0),
      family: (d.family || '').split(',').filter(Boolean),
      qtyMin: Math.max(1, toInt(d.qtyMin, 1)),
      qtyStep: Math.max(1, toInt(d.qtyStep, 1)),
      source: 'area', // 'area' = manda el sq ft · 'units' = manda la cantidad
      waste: 10,
      busy: false
    };

    this.area = buy.querySelector('[data-tp-area]');
    this.units = buy.querySelector('[data-tp-units]');
    this.len = buy.querySelector('[data-tp-len]');
    this.wid = buy.querySelector('[data-tp-wid]');

    this.restore();
    this.bind();
    this.render();
    this.bindHead();
  }

  // Trae los sq ft guardados si viene de un color o tamaño de la misma serie
  Pdp.prototype.restore = function () {
    var s = this.s;
    if (!(s.cover > 0) || !this.area) return;
    var saved = readStore();
    if (!saved || !saved.family || Date.now() - (saved.t || 0) > STORE_TTL) return;
    if (saved.family.indexOf(s.productId) === -1) return;
    if (saved.area && !this.area.value) this.area.value = saved.area;
    if (saved.waste === 10 || saved.waste === 15 || saved.waste === 20) this.setWaste(saved.waste, true);
  };

  Pdp.prototype.save = function () {
    var s = this.s;
    if (!(s.cover > 0) || !this.area) return;
    writeStore({ area: this.area.value || '', waste: s.waste, family: s.family, t: Date.now() });
  };

  // Reglas de cantidad de Shopify: mínimo y múltiplos (si el producto las tiene)
  Pdp.prototype.fixQty = function (n) {
    var s = this.s;
    n = clamp(n, 1, MAX_UNITS);
    if (n < s.qtyMin) n = s.qtyMin;
    if (s.qtyStep > 1 && n % s.qtyStep !== 0) n = Math.ceil(n / s.qtyStep) * s.qtyStep;
    return clamp(n, 1, MAX_UNITS);
  };

  Pdp.prototype.compute = function () {
    var s = this.s;
    var units = s.qtyMin;
    var area = 0;
    var need = 0;

    if (s.cover > 0) {
      area = Math.max(0, parseFloat(this.area && this.area.value) || 0);
      if (s.source === 'area') {
        // Manda el sq ft: área + % extra → siempre cajas/hojas completas
        if (area > 0) {
          need = area * (1 + s.waste / 100);
          units = Math.ceil(need / s.cover - 1e-9);
        }
      } else {
        // Manda la cantidad que eligió el cliente
        units = toInt(this.units && this.units.value, s.qtyMin);
      }
    } else {
      units = toInt(this.units && this.units.value, s.qtyMin);
    }

    units = this.fixQty(units);
    var covered = s.cover > 0 ? units * s.cover : 0;
    return { units: units, area: area, need: need, covered: covered, total: units * s.price };
  };

  Pdp.prototype.render = function () {
    var s = this.s;
    var el = this.el;
    var r = this.compute();

    if (s.cover > 0) {
      // Si manda el sq ft, el contador muestra las cajas calculadas
      if (s.source === 'area' && this.units && document.activeElement !== this.units) {
        this.units.value = String(r.units);
      }

      var outUnits = el.querySelector('[data-tp-out-units]');
      var outCover = el.querySelector('[data-tp-out-cover]');
      var outTotal = el.querySelector('[data-tp-out-total]');
      var note = el.querySelector('[data-tp-note]');

      if (outUnits) outUnits.textContent = r.units + ' ' + word(s.unit, r.units);
      if (outCover) outCover.textContent = num(r.covered) + ' sq ft';
      if (outTotal) outTotal.textContent = money(r.total);

      // Nota corta: solo los sq ft del cliente y el % extra
      var text = '';
      if (s.source === 'area' && r.area > 0) {
        text = num(r.area) + ' sq ft + ' + s.waste + '% extra';
      } else if (s.source !== 'units') {
        text = 'Enter your square feet';
      }
      if (note) note.textContent = text;
    }

    // Botón "−" apagado en el mínimo
    el.querySelectorAll('[data-tp-step="-1"]').forEach(function (b) {
      b.disabled = r.units <= s.qtyMin;
    });

    var picks = kitPicks(el, r.covered, bigTile(s.title));
    var extra = 0;
    picks.forEach(function (x) { extra += x.qty * x.price; });
    var nPick = el.querySelectorAll('[data-tp-kit-pick]:checked').length;
    var plus = nPick ? ' + ' + nPick + (nPick === 1 ? ' item' : ' items') : '';

    var cta = el.querySelector('[data-tp-pdp-add]');
    var label = el.querySelector('[data-tp-pdp-add-label]');
    if (cta && label) {
      if (!s.available) {
        cta.disabled = true;
        label.textContent = 'Sold out';
      } else {
        cta.disabled = s.busy;
        if (s.busy) {
          label.textContent = 'Adding…';
        } else if (s.cover > 0) {
          label.textContent = 'Add ' + r.units + ' ' + word(s.unit, r.units) + plus + ' to cart · ' + money(r.total + extra);
        } else {
          label.textContent = (r.units > 1 ? 'Add ' + r.units + ' to cart · ' : 'Add to cart · ') + money(r.total);
        }
      }
    }
  };

  // Extra por cortes: 10, 15 o 20 %
  Pdp.prototype.setWaste = function (v, silent) {
    if (!WASTE_TXT[v]) v = 10;
    this.s.waste = v;
    this.el.querySelectorAll('[data-tp-waste]').forEach(function (b) {
      b.setAttribute('aria-pressed', Number(b.getAttribute('data-tp-waste')) === v ? 'true' : 'false');
    });
    if (!silent) {
      var area = parseFloat(this.area && this.area.value) || 0;
      if (area > 0) this.s.source = 'area';
      this.render();
      this.save();
    }
  };

  Pdp.prototype.toggleRoom = function (btn) {
    var box = this.el.querySelector('[data-tp-room]');
    if (!box) return;
    var open = box.hidden;
    box.hidden = !open;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var lbl = btn.querySelector('[data-tp-room-label]');
    if (lbl) lbl.textContent = open ? 'Hide room size' : 'Room size';
    if (open && this.len) this.len.focus();
  };

  // Largo × ancho → llena los sq ft
  Pdp.prototype.roomCalc = function () {
    var L = parseFloat(this.len && this.len.value) || 0;
    var W = parseFloat(this.wid && this.wid.value) || 0;
    if (L > 0 && W > 0 && this.area) {
      this.area.value = num(L * W);
      this.s.source = 'area';
    }
  };

  Pdp.prototype.step = function (btn) {
    var wrap = btn.closest('.tp-step');
    var input = wrap && wrap.querySelector('[data-tp-units]');
    if (!input) return;
    var dir = toInt(btn.getAttribute('data-tp-step'), 0);
    var n = this.fixQty(this.compute().units + dir * this.s.qtyStep);
    input.value = String(n);
    if (this.s.cover > 0) this.s.source = 'units';
    this.render();
  };

  Pdp.prototype.setBusy = function (on) {
    this.s.busy = on;
    this.el.classList.toggle('is-busy', on);
    this.render();
  };

  Pdp.prototype.showError = function (msg) {
    var box = this.el.querySelector('[data-tp-pdp-error]');
    if (box) box.textContent = msg || '';
  };

  Pdp.prototype.add = function () {
    var self = this;
    var s = this.s;
    if (!s.available || s.busy || !s.variant) return;
    var r = this.compute();
    this.showError('');
    this.setBusy(true);
    var items = [{ id: Number(s.variant), quantity: r.units, sample: /\bsample\b/i.test(s.title) }];
    var picks = kitPicks(this.el, r.covered, bigTile(s.title));
    var extra = 0;
    picks.forEach(function (x) { items.push({ id: x.id, quantity: x.qty }); extra += x.qty * x.price; });
    addToCart(items)
      .then(function () {
        toast({
          name: s.title,
          detail: (s.cover > 0
            ? r.units + ' ' + word(s.unit, r.units) + ' · ' + num(r.covered) + ' sq ft'
            : 'Qty ' + r.units) + (picks.length ? ' + installation items' : ''),
          total: money(r.total + extra)
        });
      })
      .catch(function (err) {
        var msg = (err && err.message) || 'This item could not be added to your cart.';
        self.showError(msg);
        toast({ error: msg });
      })
      .then(function () {
        self.setBusy(false);
      });
  };

  Pdp.prototype.addSample = function (btn) {
    var self = this;
    var s = this.s;
    var id = btn.getAttribute('data-tp-pdp-sample');
    if (!id || btn.disabled) return;
    btn.disabled = true;
    this.showError('');
    addToCart([{ id: Number(id), quantity: 1, sample: true }])
      .then(function () {
        toast({ name: s.title + ' — Sample', detail: '1 sample', total: money(s.samplePrice) });
      })
      .catch(function (err) {
        var msg = (err && err.message) || 'The sample could not be added to your cart.';
        self.showError(msg);
        toast({ error: msg });
      })
      .then(function () {
        btn.disabled = false;
      });
  };

  Pdp.prototype.bind = function () {
    var self = this;
    var el = this.el;

    el.addEventListener('click', function (e) {
      var t = e.target;
      var b;
      if ((b = t.closest('[data-tp-room-toggle]'))) return self.toggleRoom(b);
      if ((b = t.closest('[data-tp-waste]'))) return self.setWaste(Number(b.getAttribute('data-tp-waste')));
      if ((b = t.closest('[data-tp-step]'))) return self.step(b);
      if ((b = t.closest('[data-tp-pdp-add]'))) return self.add();
      if ((b = t.closest('[data-tp-pdp-sample]'))) return self.addSample(b);
    });

    el.addEventListener('change', function (e) {
      if (e.target instanceof Element && e.target.matches('[data-tp-kit-pick]')) self.render();
    });

    el.addEventListener('input', function (e) {
      var t = e.target;
      if (t.matches('[data-tp-area]')) self.s.source = 'area';
      if (t.matches('[data-tp-units]') && self.s.cover > 0) {
        if (t.value === '') return; // mientras borra, no recalcula
        self.s.source = 'units';
      }
      if (t.matches('[data-tp-len], [data-tp-wid]')) self.roomCalc();
      if (t.matches('[data-tp-area], [data-tp-len], [data-tp-wid], [data-tp-units]')) {
        self.render();
        self.save();
      }
    });

    el.addEventListener('change', function (e) {
      // Cantidad: al salir del campo, siempre un número válido (mínimo y múltiplos)
      if (e.target.matches('[data-tp-units]')) {
        e.target.value = String(self.fixQty(toInt(e.target.value, self.s.qtyMin)));
        self.render();
      }
    });

    // Enter en los campos: no envía nada, solo confirma el número
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches('input')) {
        e.preventDefault();
        e.target.blur();
      }
    });

    // Variantes del tema (solo productos con variantes)
    document.addEventListener('variant:change', function (e) {
      var det = e.detail || {};
      var v = det.variant;
      if (!v || !v.id) return;
      if (self.scope !== document && det.formElement && !self.scope.contains(det.formElement)) return;
      self.updateVariant(v);
    });
  };

  Pdp.prototype.updateVariant = function (v) {
    var s = this.s;
    s.variant = String(v.id);
    s.price = toInt(v.price, s.price);
    s.available = !!v.available;
    if (v.quantity_rule) {
      s.qtyMin = Math.max(1, toInt(v.quantity_rule.min, 1));
      s.qtyStep = Math.max(1, toInt(v.quantity_rule.increment, 1));
    }

    var per = s.cover > 0 ? Math.round(s.price / s.cover) : s.price;
    var root = this.head || this.scope;
    var amount = root.querySelector('[data-tp-pdp-price]');
    if (amount) amount.textContent = money(per);
    this.scope.querySelectorAll('[data-tp-pdp-unit-price]').forEach(function (n) {
      n.textContent = money(s.price);
    });
    if (v.sku) {
      this.scope.querySelectorAll('[data-tp-pdp-sku][data-from-variant]').forEach(function (n) {
        n.textContent = v.sku;
      });
    }

    var inst = this.el.querySelector('[data-tp-installments-id]');
    if (inst) {
      inst.value = s.variant;
      inst.dispatchEvent(new Event('change', { bubbles: true }));
    }

    var heart = this.el.querySelector('.tp-pdp__heart');
    if (heart) heart.setAttribute('data-variant-id', s.variant);

    this.render();
  };

  // Colores y tamaños: nombre al pasar el mouse y guardar sq ft al cambiar
  Pdp.prototype.bindHead = function () {
    var self = this;
    var head = this.head;
    if (!head || head.__tpBound) return;
    head.__tpBound = true;

    var nameEl = head.querySelector('[data-tp-pdp-color-name]');
    var current = nameEl ? nameEl.textContent : '';
    var colors = head.querySelector('.tp-pdp__colors');

    if (colors && nameEl && window.matchMedia('(hover: hover)').matches) {
      colors.addEventListener('mouseover', function (e) {
        var a = e.target.closest('.tp-pdp__color');
        if (a && a.getAttribute('data-name')) nameEl.textContent = a.getAttribute('data-name');
      });
      colors.addEventListener('mouseleave', function () {
        nameEl.textContent = current;
      });
    }

    head.addEventListener('click', function (e) {
      if (e.target.closest('.tp-pdp__color, .tp-pdp__size')) self.save();
    });
  };

  /* ---------- Favoritos (Wishlist Plus) ---------- */

  function swymInit() {
    var s = window._swat;
    if (s && typeof s.initializeActionButtons === 'function') {
      try { s.initializeActionButtons('.tp-pdp'); } catch (e) { /* sin acción */ }
    }
  }

  window.SwymCallbacks = window.SwymCallbacks || [];
  window.SwymCallbacks.push(function () {
    document.documentElement.classList.add('tp-swym');
    swymInit();
  });

  /* ---------- Carga anticipada de colores y tamaños (navegación rápida) ---------- */

  function speculate() {
    try {
      if (!(window.HTMLScriptElement && HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules'))) return;
      if (document.querySelector('script[data-tp-speculation]')) return;
      var sr = document.createElement('script');
      sr.type = 'speculationrules';
      sr.setAttribute('data-tp-speculation', '');
      sr.textContent = JSON.stringify({
        prefetch: [{ source: 'document', where: { selector_matches: '.tp-pdp__color, .tp-pdp__size' }, eagerness: 'moderate' }]
      });
      document.head.appendChild(sr);
    } catch (e) { /* sin acción */ }
  }

  /* ---------- Inicio ---------- */

  function init(root) {
    (root || document).querySelectorAll('[data-tp-pdp-buy]').forEach(function (buy) {
      if (buy.__tpPdp) return;
      buy.__tpPdp = new Pdp(buy);
    });
    speculate();
    swymInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Editor de temas: al recargar la sección
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* =====================================================================
   TP INFO · Información del producto ordenada sola + kit de instalación
   ---------------------------------------------------------------------
   1) Lee la descripción TAL CUAL se sube y la ordena:
        "Etiqueta: valor" (Material, Style, Size...) → cuadrícula
        Areas → etiquetas de dónde usarlo
        secciones (Advanced Technical Details, Sealer & Installation,
        Grout Spacer...) → plegables con flechita
        bandera(s) → junto a la ficha técnica (PDF), siempre a la vista
      Si la descripción tiene otro formato, se deja tal cual (nunca se rompe).
   2) Kit de instalación: busca en la tienda el grout y el thinset que pide
      la descripción (o los más comunes) y los recomienda junto al carrito.
   3) Galería fija en computadora: las fotos acompañan mientras se baja
      (solo si caben en la pantalla), así no queda espacio vacío.
   ===================================================================== */
(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var CHEVRON = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
  var PAIR_RE = /^([^:]{1,40}?):\s*(.+)$/;
  var AREA_RE = /^(areas?|application|applications|uses?|usage|recommended use|where to use|installation|suitable for)$/i;
  // Etiquetas viejas → las de hoy (solo cómo se ven; la descripción no se toca).
  var LABEL = { quantity: 'Coverage', 'weight per box': 'Weight per Box' };
  // Documento inerte para partir párrafos: ahí no carga ninguna imagen ni corre nada.
  var INERT = document.implementation.createHTMLDocument('');

  function txt(el) {
    return (el.textContent || '').replace(/ /g, ' ').replace(/\s+/g, ' ').trim();
  }
  function make(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  /* ---------- 1. Información del producto ---------- */

  // La descripción suele venir envuelta en un <div> con estilos: se entra.
  function inner(raw) {
    var c = raw;
    while (c.children.length === 1 && /^(DIV|SECTION|ARTICLE)$/.test(c.firstElementChild.tagName)) c = c.firstElementChild;
    return c;
  }

  // Título de sección: un <h1-h6>, o un párrafo corto todo en negrita sin ":".
  function isTitle(el) {
    if (/^H[1-6]$/.test(el.tagName)) return !!txt(el);
    if (el.tagName !== 'P' && el.tagName !== 'DIV') return false;
    var t = txt(el);
    if (!t || t.length > 70 || /:\s*\S/.test(t)) return false;
    var b = el.querySelector('strong, b');
    return !!b && txt(b).length >= t.length - 1;
  }

  function rowsOf(el) {
    if (el.tagName === 'UL' || el.tagName === 'OL') return Array.prototype.map.call(el.querySelectorAll('li'), function (li) { return { t: txt(li) }; });
    if (el.tagName === 'TABLE') {
      return Array.prototype.map.call(el.querySelectorAll('tr'), function (tr) {
        var c = tr.querySelectorAll('th, td');
        return c.length >= 2 ? { k: txt(c[0]).replace(/:$/, ''), v: txt(c[1]) } : { t: txt(tr) };
      });
    }
    // Formato viejo: varias "Etiqueta: valor" en un mismo párrafo, separadas por <br>.
    if ((el.tagName === 'P' || el.tagName === 'DIV') && el.querySelector('br')) {
      return el.innerHTML.split(/<br\s*\/?>/i).map(function (h) {
        var d = INERT.createElement('div');
        d.innerHTML = h;
        return { t: txt(d) };
      }).filter(function (r) { return r.t; });
    }
    return [{ t: txt(el) }];
  }

  function parse(raw) {
    var model = { intro: [], specs: [], sections: [], flags: [] };
    var cur = null;
    var nodes = inner(raw).children;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var imgs = el.tagName === 'IMG' ? [el] : el.querySelectorAll('img');
      if (imgs.length && !txt(el)) {
        for (var f = 0; f < imgs.length; f++) model.flags.push(imgs[f]);
        continue;
      }
      if (isTitle(el)) {
        cur = { title: txt(el), items: [] };
        model.sections.push(cur);
        continue;
      }
      var rows = rowsOf(el);
      for (var r = 0; r < rows.length; r++) {
        var it = rows[r];
        if (!it.k) {
          if (!it.t) continue;
          var m = PAIR_RE.exec(it.t);
          if (m) it = { k: m[1].trim(), v: m[2].trim() };
        }
        if (cur) cur.items.push(it);
        else if (it.k) model.specs.push(it);
        else model.intro.push(it.t);
      }
    }
    return model;
  }

  // Secciones → plegables: lo técnico con su propio título; todo lo de
  // instalación (sellador, thinset, grout, espaciadores) junto.
  function groups(sections) {
    var tech = [], inst = [], other = [];
    sections.forEach(function (s) {
      if (!s.items.length) return;
      var t = s.title.toLowerCase();
      if (/install|sealer|grout|spacer|thinset|mortar|care|maint|clean/.test(t)) inst.push(s);
      else if (/technical|specification|performance|propert|detail/.test(t)) tech.push(s);
      else other.push(s);
    });
    var out = [];
    tech.forEach(function (s) { out.push({ title: s.title, parts: [s] }); });
    if (inst.length) out.push({ title: inst.length > 1 ? 'Installation & Care' : inst[0].title, parts: inst });
    other.forEach(function (s) { out.push({ title: s.title, parts: [s] }); });
    return out;
  }

  function listEl(items) {
    var dl = make('dl', 'tp-info__list');
    items.forEach(function (it) {
      var row = make('div');
      if (it.k) {
        row.appendChild(make('dt', null, LABEL[it.k.toLowerCase()] || it.k));
        row.appendChild(make('dd', null, it.v));
      } else {
        row.className = 'is-text';
        row.appendChild(make('dd', null, it.t));
      }
      dl.appendChild(row);
    });
    return dl;
  }

  function detailsEl(g) {
    var d = make('details', 'tp-info__more');
    var s = make('summary');
    s.appendChild(make('span', null, g.title));
    s.insertAdjacentHTML('beforeend', CHEVRON);
    d.appendChild(s);
    var body = make('div', 'tp-info__more-body');
    g.parts.forEach(function (part) {
      if (part.title !== g.title) body.appendChild(make('p', 'tp-info__sub', part.title));
      body.appendChild(listEl(part.items));
    });
    d.appendChild(body);
    return d;
  }

  function areasEl(value) {
    var seen = {};
    var parts = value.split(/\s*(?:,|;|\/|&|\band\b)\s*/i).filter(function (w) {
      var k = w.toLowerCase();
      if (!w || seen[k]) return false;
      seen[k] = true;
      return true;
    });
    if (!parts.length) return null;
    var box = make('div', 'tp-info__areas');
    box.appendChild(make('span', 'tp-info__areas-k', 'Where to use'));
    var ul = make('ul');
    parts.forEach(function (w) { ul.appendChild(make('li', null, w)); });
    box.appendChild(ul);
    return box;
  }

  function info(root) {
    if (root.__tpInfo) return;
    root.__tpInfo = true;
    var raw = root.querySelector('[data-tp-info-raw]');
    var foot = root.querySelector('[data-tp-info-foot]');
    if (!raw) return;
    var model;
    try { model = parse(raw); } catch (e) { return; }
    // Otro formato (menos de 3 "Etiqueta: valor"): se deja tal cual.
    if (model.specs.length < 3) return;
    try {
      var out = make('div', 'tp-info__body');
      if (model.intro.length) out.appendChild(make('p', 'tp-info__intro', model.intro.join(' ')));
      var area = null;
      var specs = model.specs.filter(function (s) {
        if (!area && AREA_RE.test(s.k)) { area = s; return false; }
        return true;
      });
      if (area) { var a = areasEl(area.v); if (a) out.appendChild(a); }
      var grid = listEl(specs);
      grid.className = 'tp-info__grid';
      out.appendChild(grid);
      groups(model.sections).forEach(function (g) { out.appendChild(detailsEl(g)); });
      raw.parentNode.insertBefore(out, raw);
      raw.hidden = true;
      // Bandera(s): siempre a la vista, junto a la ficha técnica.
      if (foot && model.flags.length) {
        var fl = make('span', 'tp-info__flags');
        model.flags.forEach(function (img) {
          var c = img.cloneNode(true);
          c.removeAttribute('style');
          c.setAttribute('loading', 'lazy');
          if (!c.getAttribute('alt')) c.setAttribute('alt', 'Country of origin');
          fl.appendChild(c);
        });
        foot.insertBefore(fl, foot.firstChild);
      }
      root.classList.add('is-ready');
      root.__tpModel = model;
    } catch (e) {
      // Cualquier sorpresa: la descripción original queda visible.
      raw.hidden = false;
      var b = root.querySelector('.tp-info__body');
      if (b) b.remove();
    }
  }

  /* ---------- 2. Kit de instalación (grout y thinset) ---------- */

  var BRANDS = 'mapei|laticrete|schluter|custom building products|custom|tec|bostik|ardex|merkrete|prism|fusion pro|spectralock|ultracolor|keracolor|permacolor|flexcolor';
  var STOP = /^(or|and|for|to|with|equivalent|premium|recommended|polymer-modified|modified-thinset|grout|grouts|thinset|thin-set|mortar|the|a|an|of|is|are|use|in)$/i;
  var KIND = {
    grout: { label: 'Grout', re: /grout|ultracolor|keracolor|permacolor|spectralock|flexcolor|fusion pro|prism/i, line: /^grout/i, fallback: ['grout'] },
    thinset: { label: 'Thinset', re: /thin-?set|mortar|all-?set|ditra-?set|\b254\b|ultraflex|kerabond|adhesive|large ?& ?heavy/i, line: /^(thin-?set|mortar|adhesive|setting)/i, fallback: ['thinset', 'mortar'] }
  };

  // De "Recommended MAPEI UltraColor Plus FA or equivalent..." saca
  // "MAPEI UltraColor Plus FA"; varias marcas → varias búsquedas.
  function queries(text, kind) {
    var out = [];
    var t = (text || '').replace(/[®™]/g, '').replace(/\//g, ' ');
    var re = new RegExp('\\b(' + BRANDS + ')\\b([^,.;()]*)', 'gi');
    var m;
    while ((m = re.exec(t))) {
      var words = (m[1] + ' ' + m[2]).split(/\s+/).filter(Boolean);
      var q = [];
      for (var i = 0; i < words.length && q.length < 5; i++) {
        if (i > 0 && STOP.test(words[i])) break;
        q.push(words[i]);
      }
      if (q.length > 1) out.push(q.join(' '));
    }
    out.sort(function (a, b) { return b.length - a.length; });
    return out.concat(KIND[kind].fallback);
  }

  function search(q) {
    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { return (d && d.resources && d.resources.results && d.resources.results.products) || []; })
      .catch(function () { return []; });
  }

  function findFor(kind, list, selfId) {
    var re = KIND[kind].re;
    var i = 0;
    function next() {
      if (i >= list.length || i >= 4) return Promise.resolve(null);
      var q = list[i++];
      return search(q).then(function (ps) {
        var hit = ps.filter(function (p) {
          var t = String(p.title || '');
          return String(p.id) !== String(selfId) && re.test(t) && !/sample/i.test(t);
        });
        hit.sort(function (a, b) { return (b.available ? 1 : 0) - (a.available ? 1 : 0); });
        return hit.length ? { product: hit[0], q: q } : next();
      });
    }
    return next();
  }

  function cents(price) {
    if (price == null || price === '') return null;
    var n = typeof price === 'number' ? price : parseFloat(String(price).replace(/[^0-9.]/g, ''));
    if (!isFinite(n)) return null;
    return typeof price === 'number' && Number.isInteger(price) && price >= 1000 ? price : Math.round(n * 100);
  }
  function money(c) {
    if (window.TP && typeof window.TP.money === 'function') return window.TP.money(c);
    return '$' + (c / 100).toFixed(2);
  }

  function kitRow(kind, hit) {
    var p = hit.product;
    var row = make('div', 'tp-kit__item');
    var a = make('a', 'tp-kit__main');
    a.href = p.url;
    var src = (p.featured_image && p.featured_image.url) || p.image || '';
    var pic = make('span', 'tp-kit__img');
    if (src) {
      var img = make('img');
      img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      img.alt = '';
      img.width = 56;
      img.height = 56;
      img.loading = 'lazy';
      pic.appendChild(img);
    }
    a.appendChild(pic);
    var t = make('span', 'tp-kit__txt');
    t.appendChild(make('span', 'tp-kit__k', hit.robot ? 'Don’t forget your grout' : 'Recommended ' + KIND[kind].label.toLowerCase()));
    t.appendChild(make('span', 'tp-kit__name', p.title));
    var c = cents(p.price);
    if (c != null) t.appendChild(make('span', 'tp-kit__price', money(c) + (hit.robot ? ' · Color-matched to this tile' : '')));
    a.appendChild(t);
    row.appendChild(a);
    // Casilla "Add with tile": se agrega junto con el azulejo (como TileBar)
    var vv = Array.isArray(p.variants) ? p.variants : [];
    if (p.available && vv.length === 1 && vv[0].id) {
      var pick = make('label', 'tp-kit__pick');
      var cb = make('input');
      cb.type = 'checkbox';
      cb.setAttribute('data-tp-kit-pick', vv[0].id);
      cb.setAttribute('data-kind', kind);
      cb.setAttribute('data-price', c != null ? c : 0);
      var lbm = /(\d+(?:\.\d+)?)\s*-?\s*(?:lb|lbs|pound)/i.exec(p.title || '');
      if (lbm) cb.setAttribute('data-lb', lbm[1]);
      if (hit.sqftBag > 0) cb.setAttribute('data-sqft-bag', hit.sqftBag);
      if (hit.mix) cb.setAttribute('data-mix', JSON.stringify(hit.mix));
      pick.appendChild(cb);
      pick.appendChild(make('span', null, 'Add with tile'));
      pick.appendChild(make('span', 'tp-kit__qty'));
      pick.lastChild.setAttribute('data-tp-kit-qty', '');
      row.__pick = pick; // va en su propia línea, fuera del enlace
    }
    // El grout se elige por color (todas las opciones); el thinset se agrega directo.
    var v = Array.isArray(p.variants) ? p.variants : [];
    if (kind === 'thinset' && p.available && v.length === 1 && v[0].id) {
      var btn = make('button', 'tp-kit__add', 'Add');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Add ' + p.title + ' to cart');
      btn.addEventListener('click', function () {
        if (!window.TP || typeof window.TP.addToCart !== 'function') { window.location.href = p.url; return; }
        btn.disabled = true;
        window.TP.addToCart([{ id: Number(v[0].id), quantity: 1 }])
          .then(function () {
            if (typeof window.TP.toast === 'function') window.TP.toast({ name: p.title, detail: 'Qty 1', total: c != null ? money(c) : '' });
          })
          .catch(function () { window.location.href = p.url; })
          .then(function () { btn.disabled = false; });
      });
      row.appendChild(btn);
    } else {
      var more = make('a', 'tp-kit__more', kind === 'grout' ? 'All colors' : 'View');
      more.href = kind === 'grout' ? (hit.all || ROOT + 'search?type=product&q=' + encodeURIComponent(hit.q)) : p.url;
      row.appendChild(more);
    }
    if (row.__pick) row.appendChild(row.__pick);
    return row;
  }

  function kit(buy) {
    var box = buy.querySelector('[data-tp-kit]');
    if (!box || box.__tpKit) return;
    box.__tpKit = true;
    var list = box.querySelector('[data-tp-kit-list]');
    var selfId = buy.getAttribute('data-product-id');
    // Las líneas "Grout:" y "Thinset:" de la descripción (si las hay).
    var model = null;
    var infoRoot = document.querySelector('[data-tp-info]');
    if (infoRoot) { info(infoRoot); model = infoRoot.__tpModel || null; }
    var lines = { grout: '', thinset: '' };
    if (model) {
      model.sections.forEach(function (s) {
        s.items.forEach(function (it) {
          if (!it.k) return;
          if (!lines.grout && KIND.grout.line.test(it.k)) lines.grout = it.v;
          if (!lines.thinset && KIND.thinset.line.test(it.k)) lines.thinset = it.v;
        });
      });
    }
    // Grout: el que eligió el robot para este azulejo (color que combina y bolsas según
    // la medida). Si el robot no encontró uno que combine, no se recomienda ninguno
    // (mejor nada que un color equivocado). El thinset se busca por la descripción.
    var robotGrout = null;
    var gj = box.querySelector('[data-tp-kit-grout]');
    if (gj) {
      try {
        var g = JSON.parse(gj.textContent);
        if (g && g.id) robotGrout = { robot: true, q: 'grout', sqftBag: Number(g.sqft) || 0, mix: g.mix || null, all: g.all || '', product: { id: 'tp-grout', title: g.title, url: g.url, featured_image: { url: g.image || '' }, price: g.price, available: true, variants: [{ id: g.id }] } };
      } catch (e) { robotGrout = null; }
    }
    Promise.all(['grout', 'thinset'].map(function (k) { return k === 'grout' ? Promise.resolve(robotGrout) : findFor(k, queries(lines[k], k), selfId); }))
      .then(function (hits) {
        var any = false;
        hits.forEach(function (h, i) {
          if (!h) return;
          list.appendChild(kitRow(i === 0 ? 'grout' : 'thinset', h));
          any = true;
        });
        if (any) box.hidden = false;
      })
      .catch(function () { /* sin kit: queda oculto */ });
  }

  /* ---------- 3. Galería fija en computadora ---------- */

  function contentHeight(el) {
    var top = Infinity, bottom = -Infinity;
    for (var c = el.firstElementChild; c; c = c.nextElementSibling) {
      var r = c.getBoundingClientRect();
      if (!r.height) continue;
      top = Math.min(top, r.top);
      bottom = Math.max(bottom, r.bottom);
    }
    return isFinite(top) ? bottom - top : el.offsetHeight;
  }

  function stickyGallery() {
    var main = document.querySelector('.product__main');
    if (!main || main.__tpStick || !document.querySelector('[data-tp-info]')) return;
    main.__tpStick = true;
    var header = document.querySelector('.shopify-section-header');
    var ticking = false;
    function update() {
      ticking = false;
      if (window.innerWidth < 990) { main.classList.remove('tp-stick'); return; }
      var top = 16;
      if (header) {
        var r = header.getBoundingClientRect();
        if (r.bottom > 0 && r.top <= 0.5) top = Math.round(r.bottom + 16);
      }
      main.style.setProperty('--tp-stick-top', top + 'px');
      // Solo si las fotos caben en la pantalla (si no, se ve normal). Se mide
      // el contenido real (la columna se estira al alto de la otra).
      main.classList.toggle('tp-stick', contentHeight(main) + top + 16 <= window.innerHeight);
    }
    function ask() { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }
    window.addEventListener('scroll', ask, { passive: true });
    window.addEventListener('resize', ask);
    window.addEventListener('load', ask);
    update();
  }

  /* ---------- Inicio ---------- */

  function start(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tp-info]').forEach(function (el) { try { info(el); } catch (e) { /* tal cual */ } });
    var later = window.requestIdleCallback || function (fn) { return setTimeout(fn, 600); };
    scope.querySelectorAll('[data-tp-pdp-buy]').forEach(function (buy) {
      later(function () { try { kit(buy); } catch (e) { /* sin kit */ } });
    });
    try { stickyGallery(); } catch (e) { /* galería normal */ }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();